import IcClose from '../../assets/image/ic_x.svg';
import { useTranslation } from '../../hook/useTranslation';

const Title = ({ title }) => {
  return (
    <div className="text-[14px] text-[1C1C1C] w-full text-left font-[700] mb-[8px]">{title}</div>
  );
};
const DotText = ({ text }) => {
  return (
    <div className="w-full flex items-start justify-start gap-[8px]">
      <div className="flex items-start justify-start mt-[-4px]">･</div>
      <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
        {text}
      </div>
    </div>
  );
};
const Text = ({ text }) => {
  return (
    <div className="w-full flex items-start justify-start gap-[8px]">
      <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
        {text}
      </div>
    </div>
  );
};

function AgreementTextEvent({ onClose = () => {} }) {
  const { t } = useTranslation();
  return (
    <div className="w-full h-full flex flex-col items-center justify-start">
      <div className="w-full flex justify-end items-center gap-2">
        <button type="button" onClick={onClose} className="cursor-pointer">
          <img src={IcClose} alt="close" className="w-[24px] h-[24px]" />
        </button>
      </div>
      <div className="text-[18px] text-[#363636] w-full text-left font-[700] my-[20px]">
        {t('agreement.event.title')}
      </div>
      <div className="w-full flex flex-col justify-start items-start my-[20px] grow overflow-y-auto gap-[20px]">
        <Text text={t('agreement.event.content')} />
        <div>
          <Title title={t('agreement.event.item1_title')} />
          <DotText text={t('agreement.event.item1_desc')} />
        </div>
        <div>
          <Title title={t('agreement.event.item2_title')} />
          <DotText text={t('agreement.event.item2_desc')} />
          <div className="my-[20px]" />
          <Text text={t('agreement.event.cookie_desc')} />
          <div className="my-[20px]" />
          <Text text={t('agreement.event.cookie_setting')} />
          <div className="my-[20px]" />
          <Text text={t('agreement.event.no_restriction')} />
        </div>
      </div>
    </div>
  );
}

export default AgreementTextEvent;
